import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { isMobile } from '../../utils/deviceInfo';

const initialState = {
    reports: {},
    insights:[], //dashboard insights
    charts:[],
    temp:{}
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.UPDATE_REPORT:  
        let obj = { ...state, ...action.val};
            return { ...state, ...action.val};

        case actionTypes.ADD_REPORT_CHARTS:  return { ...state, charts:[...action.val ]};
        
        case actionTypes.UPDATE_REPORT_CHARTS: 
            let{charts}=state 
            
            if(action.val.isRemoveFlag ){
                charts = charts.filter(e=> e._id!= action.val._id )
            } else {
                charts = charts.map( (e, idx) => {
                    if(e._id.toString() == action.val._id.toString()){
                        e = {...e,...action.val}
                    }
                    return e
                })
            }

        return { ...state, charts };




        case actionTypes.CREATE_DASHBOARD_REPORT: 
        console.log('temp: ', action.val)
         return {...state, temp: {...state.temp, ...action.val }}


        default:
            break;
    }
   
   
   
   
    return state;
}